import { r } from '../ramdaImports'
import { DeepPartial } from 'ui/lib/misc/DeepPartial'

export const deepMergeRight = <T extends {}>(
	...objects: DeepPartial<T>[]
): T => {
	return r.reduce(r.mergeDeepRight, {} as any, objects) as T
}
